export default "__VITE_ASSET__Cwx6MKyE__"